export const searchOverflowToggler = (isHidden: boolean) => {
    const overflowBodyClass = 'search-body-scroll--disabled';

    if (isHidden) {
      document.body?.classList.add(overflowBodyClass);
    } else {
      document.body?.classList.remove(overflowBodyClass);
    }
};
